import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../Redux/actions/authActions";
import { hasUserFilledSurvey } from "../../Redux/actions/commonActtion";
import { Scrollx_animate } from "../../assets/icons";
import SuccessModal from "../Dashboard/SuccessModal";
import SignUpWithGoogle from "../GoogleSignUp/SignUpWithGoogle";
import "./login.css";

export default function NewLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMesg, setErrorMesg] = useState("");
  const [path, setPath] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signInLoading, setSignInLoading] = useState(false);

  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setSignInLoading(true);
    try {
      const res = await dispatch(login(email, password));
      const userFilledSurvey = await hasUserFilledSurvey();
      localStorage.setItem(
        "userFilledSurvey",
        JSON.stringify(userFilledSurvey)
      );
      if (res?.status === 200) {
        setErrorMesg(`${res?.data?.message} or login with registred email`);
        setSuccessModal(true);
        setPath("/register");
        setSignInLoading(false);
      } else if (
        res?.response?.status === 400 &&
        res?.response?.data?.error &&
        !res?.response?.data?.success
      ) {
        setErrorMesg(
          res?.response?.data?.error
            ? "Incorrect username or password."
            : "oops"
        );
        setSuccessModal(true);
        setSignInLoading(false);
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      console.log("error", error);
      setSignInLoading(false);
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className="w-full h-full">
      <div className={"main_div"}>
        <div>
          {successModal && (
            <SuccessModal
              successModal={successModal}
              setSuccessModal={setSuccessModal}
              errorMesg={errorMesg}
              path={path}
            />
          )}
        </div>

        {signInLoading && (
          <div className="modal-overlayLoader">
            <img
              src={Scrollx_animate}
              className="absolute opacity-80"
              width="140px"
              height="140px"
            />
           <p className="mt-[8rem] text-[0.9rem] text-white">Signing in...</p>
            {/* <LoaderGlobal /> */}
          </div>
        )}

        <div className="w-full h-full  LoginLeft-block  flex">
          {/* Left Block */}
          <div className="lg:w-[55%] loginLeft-block flex justify-center items-center">
            <div className=" text-white text-4xl flex flex-col justify-center items-center text-center">
              <h1 className="Syne700 py-1">ScrollX is a game changer!</h1>
              <h1 className="Syne700 py-1">It saved us days of works to</h1>
              <h1 className="Syne700 py-1">submit our film to festivals.</h1>
              <h3 className="text-base mt-5 FontFamily-Avenir-reg">
                - Moon Unit Productions
              </h3>
            </div>
          </div>
          {/* Right Block */}
          <div className="w-[45%]  loginRight-block flex justify-center items-center bg-white">
            <div className=" w-[60%] h-1/2 flex flex-col justify-center items-center loginRight-blockPhone">
              <div className="flex flex-col justify-center items-center ">
                <h1 className="text-black text-[30px] uppercase Syne700  pb-4">
                  Welcome
                </h1>
                <h2 className="text-black xl:text-2xl Syne700">
                  Create End Credits Now
                </h2>
                <h3 className="FontFamily-Avenir-reg xl:text-lg text-[#585858] pt-[10px]">
                  Not a member?{" "}
                  <Link to="/register">
                    <span className="text-[#5100ff] xl:text-lg FontFamily-Avenir-reg">
                      Sign up now!
                    </span>
                  </Link>
                </h3>
                {/* <button className='xl:w-[85%] my-3 mt-4 flex justify-center items-center border-[2px] border-[#797979] rounded-xl py-1 px-3 '><img className='w-6 mr-3' src={Google_Logo} alt="" /><h1 className='FontFamily-Avenir-reg xl:text-base text-black'>Sign in with Google</h1></button> */}
                <SignUpWithGoogle />
              </div>
              <div className="w-full flex justify-center items-center pt-[14px] px-1">
                <div className="xl:w-[20%] h-[1px] self-center bg-[#797979] mt-[4px]"></div>
                <div className="xl:w-[65%] 2xl:w-[55%] text-center FontFamily-Avenir-reg xl:text-lg text-gray-800 split-sign">
                  or sign in with your email{" "}
                </div>
                <div className="xl:w-[20%]  h-[1px] self-center bg-[#797979]"></div>
              </div>
              <div className="w-full">
                <form onSubmit={submitHandler}>
                  <div className="mb-6 mt-6 flex">
                    {/* <label htmlFor="email" className=" xl:text-lg FontFamily-Avenir-reg mb-1 pl-[30px]">Email address</label> */}
                    <input
                      className=" email-place NewLoginInput inputBorder w-full FontFamily-Avenir-reg"
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email"
                      required
                    />
                    <div></div>
                  </div>
                  <div className="mb-8 flex items-center">
                    {/* <label htmlFor="password" className=" xl:text-lg FontFamily-Avenir-reg mb-1 pl-[30px]">Password</label> */}
                    <input
                      className="NewLoginInput inputBorder FontFamily-Avenir-reg"
                      type={showPassword ? "text" : "password"}
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                      required
                    />
                    <div
                      onClick={handleShowPassword}
                      className="absolute ml-[62%] sm:ml-[20%] md:ml-[24.5%] text-black w-5 h-5 cursor-pointer"
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </div>
                  </div>
                  <div className="flex flex-col justify-center items-center w-full">
                    <div className=" SignIN-btn transition-transform">
                      <button
                        type="submit"
                        className="px-5 py-[8px] yellow-gradient FontFamily-Avenir-reg tracking-widest rounded-2xl uppercase xl:text-base"
                      >
                        Sign in
                      </button>
                    </div>
                    <div className="py-[6px] mt-[4px]">
                      <span className="">
                        <Link
                          className=" text-sm FontFamily-Avenir-reg "
                          to="/forgotpassword"
                        >
                          Forgot your Password?
                        </Link>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* After Login, Mobile View Response */}
      {/* <div id="warning-messageas" style={{ width: '100%', height: '100%' }}>
        <div className='w-full h-full  LoginLeft-block md:flex md:flex-row flex flex-col-reverse justify-center items-center  '>
          <div className='md:w-[55%] h-1/2  flex justify-center items-center'>
            <div className=' text-white text-4xl flex flex-col justify-center items-center text-center'>
              <img className='w-80' src={laptopScreenV3} alt="" />
            </div>
          </div>
          <div className=' md:w-[45%] w-full md:h-full h-1/2   flex justify-center items-center bg-white'>
            <div className=' md:w-[85%] w-[90%]  h-1/2 flex flex-col justify-center items-center '>
              <div className='flex flex-col justify-center items-center '>
                <h1 className='text-black md:text-[26px] text-xl  Syne700  pb-4 text-center'>Excited to use ScrollX?</h1>
                <h3 className='FontFamily-Avenir-reg text-sm text-[#585858] py-[10px] text-center'>For the best experience, grab your laptop or desktop because our app is not available on phones.</h3>
                <h3 className='FontFamily-Avenir-reg text-sm text-[#585858] pt-[10px] text-center'>Lights, camera, action awaits on the big screen! 🎥✨</h3>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}
